export const ExperimentTitleNames = {
  LTSHardPaywall: "LTS 70 Hard Paywall",
  PaywallMasking: "Paywall Masking",
  RecirculationWidget: "Article page recirculation widget test",
};
